export const skills = {
  frontend: ["React.js", "Next.js", "Tailwind CSS", "HTML5", "CSS3", "JavaScript"],
  backend: ["Node.js", "Express.js", "MongoDB", "Firebase", "REST API"],
  tools: ["Git", "GitHub", "VS Code", "Figma"],
};
